<template>
    <transition name="fade">
        <div class="c-process" v-show="showFlag">
            <div class="wrap">
                <div class="item">
                    <el-progress :text-inside="true" :stroke-width="18" :percentage="percentage"></el-progress>
                </div>
                <div class="item">{{text}}</div>
            </div>
        </div>
    </transition>
</template>

<script type="text/ecmascript-6">
    export default {
        props: {
            delay: {
                type: Number,
                default: 2000
            },
            isAutoHide: {
                type: Boolean,
                default: false
            },
            percentage: {
                type: Number,
                default: 0
            },
            text: {
                type: String,
                default: ''
            }
        },
        data() {
            return {
                showFlag: false
            };
        },
        methods: {
            show(delay) {
                this.showFlag = true;
                clearTimeout(this.timer);
                if (this.isAutoHide) {
                    this.timer = setTimeout(() => {
                        this.hide();
                    }, delay || this.delay);
                }
            },
            hide() {
                this.showFlag = false;
            }
        }
    };
</script>

<style lang="scss" rel="stylesheet/scss">
    @import "~assets/scss/compile";
    @import "progressGlobal";
</style>



// WEBPACK FOOTER //
// src/base/progressGlobal/progressGlobal.vue